import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
import SAR from "@componentsShared/SAR/SAR";
import { twMerge } from "tailwind-merge";
import Markdown from "markdown-to-jsx";
var UpgradeWarrantyModalContent = function UpgradeWarrantyModalContent(_ref) {
  var _ref2, _warrantyDetails$upda, _ref3, _warrantyDetails$titl, _warrantyDetails$pric, _ref4, _warrantyDetails$vat, _warrantyDetails$tota;
  var item = _ref.item,
    vat = _ref.vat,
    isDowngrade = _ref.isDowngrade,
    isCollectPayment = _ref.isCollectPayment,
    onConfirm = _ref.onConfirm,
    onKeep = _ref.onKeep,
    warrantyDetails = _ref.warrantyDetails,
    isBnpl = _ref.isBnpl;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "h-full overflow-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6 md:gap-8 md:max-w-[484px] justify-center md:mx-auto h-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full flex justify-center"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/professional-car.png",
    alt: ""
  })), /*#__PURE__*/React.createElement("h3", {
    className: "text-primary-new text-base md:text-2xl font-bold leading-8 text-center"
  }, isDowngrade ? /*#__PURE__*/React.createElement(React.Fragment, null, tShort("warranty/downgrade_title", {
    ns: "web_tracking"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, tShort("warranty/upgrade_title", {
    ns: "web_tracking"
  }))), /*#__PURE__*/React.createElement("p", {
    className: "text-black-primary font-normal leading-8 text-center text-xs"
  }, isDowngrade ? /*#__PURE__*/React.createElement(React.Fragment, null, tShort("warranty/downgrade_description", {
    ns: "web_tracking"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, tShort("warranty/upgrade_description", {
    ns: "web_tracking"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full md:rounded rounded-xl bg-[#F2F2F2] md:pt-3 md:pb-6 md:px-4 p-2 flex flex-col  relative gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-xs font-normal leading-4 text-[#6B7EA5]"
  }, tShort("warranty/upgrade_type", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-black-primary leading-6 text-base font-semibold"
  }, (_ref2 = (_warrantyDetails$upda = warrantyDetails === null || warrantyDetails === void 0 ? void 0 : warrantyDetails.update_type) !== null && _warrantyDetails$upda !== void 0 ? _warrantyDetails$upda : item === null || item === void 0 ? void 0 : item.title) !== null && _ref2 !== void 0 ? _ref2 : "—")), /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-gainsboro w-full h-px"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-xs font-normal leading-4 text-[#6B7EA5]"
  }, tShort("warranty/upgrade_chosen", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-black-primary leading-6 text-base font-semibold"
  }, /*#__PURE__*/React.createElement(Markdown, {
    className: "[&>strong]:font-bold"
  }, (_ref3 = (_warrantyDetails$titl = warrantyDetails === null || warrantyDetails === void 0 ? void 0 : warrantyDetails.title) !== null && _warrantyDetails$titl !== void 0 ? _warrantyDetails$titl : item === null || item === void 0 ? void 0 : item.subtitle) !== null && _ref3 !== void 0 ? _ref3 : "—"))), /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-gainsboro w-full h-px"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-xs font-normal leading-4 text-[#6B7EA5]"
  }, tShort("warranty/upgrade_price", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-0.5"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-black-primary leading-6 text-base font-semibold"
  }, (_warrantyDetails$pric = warrantyDetails === null || warrantyDetails === void 0 ? void 0 : warrantyDetails.price) !== null && _warrantyDetails$pric !== void 0 ? _warrantyDetails$pric : "—"))), /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-gainsboro w-full h-px"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex items-start justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-0.5"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-xs font-normal leading-4 text-[#6B7EA5]"
  }, tShort("warranty/upgrade_vat", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-[10px] font-normal leading-3 text-[#b0b0b0] max-w-[140px]"
  }, tShort("warranty/upgrade_vat_note", {
    ns: "web_tracking"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-0.5"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-black-primary leading-6 text-base font-semibold"
  }, (_ref4 = (_warrantyDetails$vat = warrantyDetails === null || warrantyDetails === void 0 ? void 0 : warrantyDetails.vat) !== null && _warrantyDetails$vat !== void 0 ? _warrantyDetails$vat : vat) !== null && _ref4 !== void 0 ? _ref4 : "—"), !warrantyDetails && vat && /*#__PURE__*/React.createElement(SAR, {
    className: "text-black-primary"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "h-px w-full bg-gray-gainsboro"
  }), /*#__PURE__*/React.createElement("div", {
    className: "w-full flex items-center justify-between px-2"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-[#6B7EA5] text-sm md:text-lg font-normal leading-7"
  }, tShort("warranty/upgrade_total", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-0.5"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-lg md:text-2xl font-bold leading-8 text-success"
  }, (_warrantyDetails$tota = warrantyDetails === null || warrantyDetails === void 0 ? void 0 : warrantyDetails.total_price) !== null && _warrantyDetails$tota !== void 0 ? _warrantyDetails$tota : item ? item.price.current === 0 ? tShort("warranty/free", {
    ns: "web_tracking"
  }) : item.price.current_formatted : "—"))))), /*#__PURE__*/React.createElement("div", {
    className: "w-full flex items-center justify-center"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-sm md:text-base font-noraml leading-6 text-black-primary"
  }, isBnpl ? tShort("warranty/upgrade_note_bnpl", {
    ns: "web_tracking"
  }) : tShort("warranty/upgrade_note", {
    ns: "web_tracking"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center gap-3 md:flex-row justify-center"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onConfirm,
    className: twMerge("w-full outline-0 border-0 bg-primary-new text-white rounded px-4 py-3 text-base font-bold leading-6 cursor-pointer md:max-w-fit min-w-[180px] max-w-full", !isDowngrade && "min-w-[318px]")
  }, isCollectPayment ? tShort("warranty/upgrade_confirm", {
    ns: "web_tracking"
  }) : isDowngrade ? tShort("warranty/downgrade_confirm", {
    ns: "web_tracking"
  }) : tShort("warranty/confirm", {
    ns: "web_tracking"
  })), isDowngrade && /*#__PURE__*/React.createElement("button", {
    onClick: onKeep,
    className: "w-full outline-0 border border-primary-new bg-white text-primary-new rounded px-4 py-3 text-base font-bold leading-6 cursor-pointer border-solid max-w-full md:max-w-fit min-w-[180px]"
  }, tShort("warranty/downgrade_keep", {
    ns: "web_tracking"
  }))))));
};
export default UpgradeWarrantyModalContent;